export default "__VITE_ASSET__36149ae6__"